var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9997 2.33398C10.943 2.33398 8.45801 4.81898 8.45801 7.87565C8.45801 10.874 10.803 13.3007 13.8597 13.4057C13.953 13.394 14.0463 13.394 14.1163 13.4057C14.1397 13.4057 14.1513 13.4057 14.1747 13.4057C14.1863 13.4057 14.1863 13.4057 14.198 13.4057C17.1847 13.3007 19.5297 10.874 19.5413 7.87565C19.5413 4.81898 17.0563 2.33398 13.9997 2.33398Z",
    fill: "#4E277B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.9271 16.5084C16.6721 14.3384 11.3638 14.3384 8.08544 16.5084C6.60378 17.5 5.78711 18.8417 5.78711 20.2767C5.78711 21.7117 6.60378 23.0417 8.07378 24.0217C9.70711 25.1184 11.8538 25.6667 14.0004 25.6667C16.1471 25.6667 18.2938 25.1184 19.9271 24.0217C21.3971 23.03 22.2138 21.7 22.2138 20.2534C22.2021 18.8184 21.3971 17.4884 19.9271 16.5084Z",
    fill: "#40196D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2371 20.2768L16.2638 19.2502C16.6021 18.9118 16.6021 18.3518 16.2638 18.0135C15.9255 17.6752 15.3655 17.6752 15.0271 18.0135L14.0005 19.0402L12.9738 18.0135C12.6355 17.6752 12.0755 17.6752 11.7371 18.0135C11.3988 18.3518 11.3988 18.9118 11.7371 19.2502L12.7638 20.2768L11.7371 21.3035C11.3988 21.6419 11.3988 22.2019 11.7371 22.5402C11.9121 22.7152 12.1338 22.7969 12.3555 22.7969C12.5771 22.7969 12.7988 22.7152 12.9738 22.5402L14.0005 21.5135L15.0271 22.5402C15.2021 22.7152 15.4238 22.7969 15.6455 22.7969C15.8671 22.7969 16.0888 22.7152 16.2638 22.5402C16.6021 22.2019 16.6021 21.6419 16.2638 21.3035L15.2371 20.2768Z",
    fill: "#40196D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileDelete);
export default __webpack_public_path__ + "static/media/profile-delete.5a782a0e547a7dcea651b7efb5d6699b.svg";
export { ForwardRef as ReactComponent };